export const isMobile = ( 'ontouchstart' in window )

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

export const mapLinear = ( x, a1, a2, b1, b2 ) => b1 + ( x - a1 ) * ( b2 - b1 ) / ( a2 - a1 )